import React, { useEffect, useMemo, useState, useRef } from "react";
import { createPortal } from "react-dom";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import * as CompanyActions from "../../store/actions/company";
import { setProfile } from "../../store/actions/user";
import { Link } from "react-router-dom";
import { Layout, Menu, Avatar, Switch, Dropdown, Modal } from "antd";
import { UserOutlined, WalletOutlined, LogoutOutlined } from "@ant-design/icons";
import logo from "../../assets/images/logo.png";
import MotionVideo from "../../assets/video/Motion.mp4";
import Cookie from "js-cookie";
import { Select } from "antd";
import { toast } from "react-toastify";
import { ENTERPRISE_ROLE, PAGE_TITLES, PROFESSIONAL_ROLE } from "../../constant";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import {
  BarChart,
  Close,
  Description,
  Home,
  Insights,
  KeyboardDoubleArrowLeftOutlined,
  KeyboardDoubleArrowRightOutlined,
  LocationCity,
  People,
  PersonSearch,
  BookOutlined,
} from "@mui/icons-material";
import moment from "moment";
import RenewSubscription from "../renew-subscription";
import { BounceLoader, MoonLoader } from "react-spinners";
import { LayoutPageSkeleton } from "../page-skeleton";
import { getInitials } from "../../utils";
import { getList } from "../../store/actions/leads-list";
import TargetListProgresstModal from "../../pages/leads/pages/ai-recommendation/components/target-list-progress";
import AiTargetError from "../../pages/leads/pages/ai-recommendation/components/target-error";
import TargetListCompaniesProgresstModal from "../../pages/leads/pages/ai-recommendation/components/target-list-companies-progress";
import Feedback from "../feedback";

const { Option } = Select;
const { Header, Sider, Content } = Layout;

const needsOnboarding = (user) => {
  if (!user) return false;
  if (user.role === ENTERPRISE_ROLE) return false;
  const role = user?.onboarding_role;
  const roleOther = user?.onboarding_role_other;
  const hear = user?.onboarding_hear_about;
  const hearOther = user?.onboarding_hear_about_other;

  if (!role) return true;
  if (role === "Other" && !String(roleOther ?? "").trim()) return true;
  if (!hear) return true;
  if (hear === "Other" && !String(hearOther ?? "").trim()) return true;

  return false;
};

const MainLayout = (props) => {
  const { http } = global.services;

  const loading = useSelector((state) => state.AppReducer.loading);
  const companies = useSelector((state) => state.CompanyReducer.companies);
  const selected = useSelector((state) => state.CompanyReducer.selected_company);
  const companiesAlgo = useSelector((state) => state.algoReducer.companies);
  const isListGenerating = Object.values(companiesAlgo).some((c) => c.running);
  const listPreview = Object.values(companiesAlgo).some((c) => c.preview);

  const [collapsed, setCollapsed] = useState(false);
  const [exiprePreview, setExiprePreview] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [renewLoader, setRenewLoader] = useState(false);

  const [state, setState] = useState({
    menu: ["/"],
    profile: null,
    subscription: null,
  });
  const [isShared, setShared] = useState(false);
  const [companyAlgoProgressPreview, setCompanyAlgoProgressPreview] = useState(false);
  const [highlightFlorenceNav, setHighlightFlorenceNav] = useState(false);
  const [florenceNudgePos, setFlorenceNudgePos] = useState(null);
  const florenceNavRef = useRef(null);

  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const hasUsername = state?.profile?.username && state?.profile?.username.length > 1;

  useEffect(() => {
    initUser();
    initMenu();

    // return () => state;
  }, []);

  useEffect(() => {
    let highlightTimer;
    const handleHighlightFlorenceNav = () => {
      setHighlightFlorenceNav(true);
      clearTimeout(highlightTimer);
      highlightTimer = setTimeout(() => {
        setHighlightFlorenceNav(false);
      }, 8000);
    };

    window.addEventListener("highlight-florence-nav", handleHighlightFlorenceNav);
    return () => {
      window.removeEventListener("highlight-florence-nav", handleHighlightFlorenceNav);
      clearTimeout(highlightTimer);
    };
  }, []);

  useEffect(() => {
    if (location.pathname.includes("ai-recommendation")) {
      setHighlightFlorenceNav(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (!highlightFlorenceNav) {
      setFlorenceNudgePos(null);
      return;
    }

    const updatePosition = () => {
      const el = florenceNavRef.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      setFlorenceNudgePos({
        top: rect.top + rect.height / 2,
        left: rect.right + 14,
      });
    };

    updatePosition();
    window.addEventListener("resize", updatePosition);
    window.addEventListener("scroll", updatePosition, true);
    return () => {
      window.removeEventListener("resize", updatePosition);
      window.removeEventListener("scroll", updatePosition, true);
    };
  }, [highlightFlorenceNav, collapsed]);

  const generatingCount = useMemo(() => {
    return Object.values(companiesAlgo).filter((c) => c.running).length;
  }, [companiesAlgo]);

  useEffect(() => {
    let menuListener = history.listen((location, action) => {
      initMenu();
    });

    return () => menuListener;
  }, []);

  useEffect(() => {
    if (props && props.menu) setState((prev) => ({ ...prev, menu: props.menu }));
  }, [props?.menu]);

  const initUser = async () => {
    let { data } = await http.get(`user`);
    dispatch(setProfile(data.user));
    if (data.user.is_subscribed && data.subscription?.cancelled) {
      setExiprePreview(true);
    }
    initialization(data.user);
    setState((prev) => ({
      ...prev,
      profile: data.user,
      subscription: data.subscription,
    }));
  };

  const initLeadsList = async (data) => {
    const url = data ? `user-lead-list/${data.id}` : `user-lead-list`;
    http.get(url).then(({ data }) => {
      dispatch(getList(data));
    });
  };

  const initialization = async (user) => {
    // TODO: Remove this when we restrict professional users from accessing enterprise features
    // if (user.role === PROFESSIONAL_ROLE) {
    //   initLeadsList();
    //   setLoading(false);
    //   // history.push("/dataset");
    //   return;
    // }
    let { data } = await http.get(`user-company`);
    setLoading(false);
    const selectedCompany = localStorage.getItem("selected_company");
    const selectedCompanyDetail = data?.find((x) => x.id === parseInt(selectedCompany));
    if (data.length > 0) {
      dispatch(CompanyActions.setCompanies(data));
      dispatch(CompanyActions.setSelectedCompany(selectedCompanyDetail ?? data[0]));
      initLeadsList(selectedCompanyDetail ?? data[0]);
      if (!selectedCompanyDetail) {
        localStorage.setItem("selected_company", selectedCompany);
      }
    }
  };

  const initMenu = async () => {
    let activeMenu =
      history.location.pathname == "/" || history.location.pathname == "/home"
        ? "/"
        : history.location.pathname;
    setState((prev) => ({ ...prev, menu: [activeMenu] }));
  };

  const toggle = () => {
    setCollapsed(!collapsed);
  };

  const logout = () => {
    http.post("logout");
    Object.keys(Cookie.get()).map(function (cookieName) {
      Cookie.remove(cookieName);
    });
    // history.replace("/")
    window.location.replace("/");
  };

  const confirmSignOut = () => {
    Modal.confirm({
      className: "theme-confirm-modal theme-confirm-modal--sign-out",
      icon: <LogoutOutlined className="theme-confirm-modal__icon" />,
      title: "Sign out?",
      content: "You will need to sign in again to access your account.",
      okText: "Sign out",
      cancelText: "Cancel",
      centered: true,
      width: 400,
      onOk: () => {
        logout();
      },
    });
  };

  const click = (e) => {
    let active = [`${e.key}`];
    setState((prev) => ({ ...prev, menu: active }));
  };

  const changeSelected = (e) => {
    let company = companies.filter((c) => c.id === e)[0];
    dispatch(CompanyActions.setSelectedCompany(company));
    initLeadsList(company);
  };

  const setSharedHelper = (value) => {
    setShared(value);
    const payload = {
      company_name: selected.company_name,
      shared: value,
      organization: value ? state.profile?.organization : null,
    };
    http
      .put(`user-company/${selected.id}`, payload)
      .then(({ data }) => {
        dispatch(CompanyActions.updateCompanyName(data));
      })
      .catch(() => toast.error("Error updating company"));
  };

  const renewSubscription = () => {
    if (renewLoader) return;
    setRenewLoader(true);
    http
      .get("subscription-session")
      .finally(() => setRenewLoader(false))
      .then(({ data }) => {
        window.location.href = data.url;
      })
      .catch(() => {});
  };

  const isEnterpriseUser = state.profile?.role === ENTERPRISE_ROLE;
  // const isMenuDisabled = companies?.length <= 0 && isEnterpriseUser;
  const isMenuDisabled = false;
  const isSubscriptionExpired =
    !state?.profile?.is_subscribed && !isEnterpriseUser && !state?.profile?.free_trial;
  const isAdmin = state.profile?.is_superuser;

  const companyDetailPage = location.pathname === "/company-detail";
  const investorsPage =
    location.pathname === "/dataset" || location.pathname.includes("investors");
  const onboardingRequired = needsOnboarding(state.profile);
  const onboardingPage = location.pathname === "/onboarding";

  useEffect(() => {
    if (isLoading) return;
    if (!state.profile) return;

    if (onboardingRequired && !onboardingPage) {
      sessionStorage.setItem("postOnboardingRedirect", location.pathname || "/home");
      history.replace("/onboarding");
    }

    if (!onboardingRequired && onboardingPage) {
      const returnTo = sessionStorage.getItem("postOnboardingRedirect") || "/home";
      sessionStorage.removeItem("postOnboardingRedirect");
      history.replace(returnTo);
    }
  }, [
    isLoading,
    onboardingRequired,
    onboardingPage,
    state.profile,
    history,
    location.pathname,
  ]);

  // HOOKS
  useEffect(() => {
    const currentLoc = location.pathname;
    let title = "Firm Overview";
    if (currentLoc !== "/") {
      const page = PAGE_TITLES.find((page) => {
        return currentLoc.includes(page.key);
      });
      title = page?.title ?? "404";
    }
    ReactGA.send({
      hitType: "pageview",
      page: currentLoc,
      title: title,
    });
  }, [location]);

  useEffect(() => {
    if (!selected?.id) return;
    setShared(selected.shared ?? false);
  }, [selected]);

  const generateMenu = () => {
    const menu = [
      {
        label: (
          <Link to="/my-profile">
            <UserOutlined /> My profile
          </Link>
        ),
        key: "0",
      },
      {
        type: "divider",
      },
      {
        label: (
          <span onClick={confirmSignOut}>
            <LogoutOutlined /> Sign out
          </span>
        ),
        key: "2",
      },
    ];

    if (state.profile?.role === PROFESSIONAL_ROLE) {
      menu.splice(
        1,
        0,
        {
          type: "divider",
        },
        {
          label: (
            <Link to="/subscription">
              <WalletOutlined /> My Subscription
            </Link>
          ),
          key: "1",
        },
      );
    }

    return menu;
  };

  return (
    <>
      {highlightFlorenceNav &&
        florenceNudgePos &&
        createPortal(
          <div
            className="florence-nav-nudge"
            role="status"
            style={{
              top: florenceNudgePos.top,
              left: florenceNudgePos.left,
            }}
          >
            <span className="florence-nav-nudge__arrow" aria-hidden />
            <span className="florence-nav-nudge__header">
              <MoonLoader size={12} speedMultiplier={0.6} color="#605bff" />
              <strong>Florence is running</strong>
            </span>
            <span className="florence-nav-nudge__text">
              We started building your target list. Open this tab anytime to follow
              progress.
            </span>
          </div>,
          document.body,
        )}
      {exiprePreview && (
        <div className="subscription-alert">
          <p>
            Your subscription has been canceled. However, you will retain access to all
            subscription features until{" "}
            {moment
              .unix(state.subscription?.expire_at ?? new Date())
              .format("MMMM DD, YYYY")}
            {/* at{" "}
              {moment
                .unix(state.subscription?.expire_at ?? new Date())
                .format("HH:mm a")} */}
            .
          </p>
          <button className="renew-btn" onClick={renewSubscription}>
            Renew now
          </button>
          {renewLoader && <BounceLoader size={10} color="#fff" />}
          <button className="close-btn" onClick={() => setExiprePreview(false)}>
            <Close />
          </button>
        </div>
      )}
      <div className="leads-header">
        <Link to="/home" className="logo logo-main">
          Conceptor
        </Link>
        <div
          className="flex items-center justify-end"
          style={{ width: 1000, maxWidth: "100%" }}
        >
          {isListGenerating && (
            <button
              className="algo-progress-box"
              onClick={() => setCompanyAlgoProgressPreview(true)}
            >
              <MoonLoader size={12} speedMultiplier={0.5} />
              Florence generating {generatingCount} list{generatingCount > 1 ? "s" : ""}
              <span className="progress-btn">View progress</span>
            </button>
          )}
          {state.profile?.organization && companyDetailPage && companies.length >= 1 && (
            <div
              onClick={() => setSharedHelper(!isShared)}
              className={`shared-with-organization ${
                !selected?.created_by_user ? "disabled" : ""
              }`}
            >
              <span className="title">Shared with Organization</span>
              <Switch checked={isShared} disabled={!selected?.created_by_user} />
            </div>
          )}
          {/* TODO: Remove this when we restrict professional users from accessing enterprise features */}
          {/* {isEnterpriseUser && ( */}

          {!onboardingRequired && (
            <div className="flex items-center select-company">
              <Select
                defaultValue={""}
                value={selected.id || ``}
                style={{ width: "100%" }}
                onChange={changeSelected}
              >
                {companies.map((company, index) => (
                  <Option key={index} value={company.id}>
                    {company.company_name}
                    {!company.created_by_user ? (
                      <i style={{ color: "rgb(146 146 146)", fontSize: 12 }}> (Shared)</i>
                    ) : (
                      ""
                    )}
                  </Option>
                ))}
              </Select>
            </div>
          )}
          {/* )} */}
          <Dropdown
            menu={{ items: generateMenu() }}
            trigger={["click"]}
            overlayClassName="profile-dropdown"
          >
            <Avatar
              src={state?.profile?.profile_picture}
              shape="circle"
              size="medium"
              className={`user-avatar ${!hasUsername ? "large" : ""}`}
            >
              {hasUsername ? getInitials(state?.profile?.username) : <UserOutlined />}
            </Avatar>
          </Dropdown>
        </div>
      </div>
      <Layout>
        {!onboardingRequired ? (
          <Sider
            trigger={null}
            collapsible
            collapsed={collapsed}
            style={{
              height: "calc(100vh - 65px)",
            }}
            className={`leads-sidebar ${collapsed ? "collapsed" : ""}`}
          >
            <button className="sidebar-toggle" onClick={toggle}>
              {collapsed ? (
                <KeyboardDoubleArrowRightOutlined />
              ) : (
                <KeyboardDoubleArrowLeftOutlined />
              )}
            </button>
            <Menu
              theme="light"
              mode="inline"
              defaultSelectedKeys={
                history.location.pathname == "/" || history.location.pathname == "/home"
                  ? "/"
                  : history.location.pathname
              }
              selectedKeys={
                history.location.pathname == "/" || history.location.pathname == "/home"
                  ? "/"
                  : history.location.pathname
              }
              className="menu-sidebar"
              onClick={click}
            >
              {/* TODO: Remove this when we restrict professional users from accessing enterprise features */}
              {/* {isEnterpriseUser && ( */}
              <>
                <Menu.Item
                  key="/"
                  disabled={isMenuDisabled}
                  icon={<Home />}
                  style={{ zIndex: 100 }}
                >
                  Firm Overview
                  <Link to="/home" />
                </Menu.Item>
                {isAdmin && (
                  <>
                  <Menu.Item key="/analytics" icon={<BarChart />} style={{ zIndex: 100 }}>
                    Admin Analytics
                    <Link to="/analytics" />
                  </Menu.Item>
                  <Menu.Item key="/blogs" icon={<BookOutlined />} style={{ zIndex: 100 }}>
                    Blogs
                    <Link to="/blogs" />
                  </Menu.Item>
                  </>
                )}

                <Menu.Item
                  key="/companies"
                  disabled={isMenuDisabled}
                  icon={<LocationCity />}
                  style={{ zIndex: 100 }}
                >
                  Companies
                  <Link to="/companies" />
                </Menu.Item>

                <Menu.Item
                  key="/company-detail"
                  disabled={isMenuDisabled}
                  icon={<Description />}
                  style={{ zIndex: 100 }}
                >
                  Company Detail
                  <Link to="/company-detail" />
                </Menu.Item>
                <Menu.Item
                  key="/ai-recommendation"
                  disabled={isMenuDisabled}
                  icon={<Insights />}
                  style={{ zIndex: 100 }}
                >
                  <span className="florence-nav-label" ref={florenceNavRef}>
                    Florence
                  </span>
                  <Link to="/ai-recommendation" />
                </Menu.Item>
              </>
              {/* )} */}
              <Menu.Item key="/dataset" icon={<PersonSearch />} style={{ zIndex: 100 }}>
                Investor Search
                <Link to="/dataset" />
              </Menu.Item>
              <Menu.Item
                key="/leads-manager"
                disabled={isMenuDisabled}
                icon={<People />}
                style={{ zIndex: 100 }}
              >
                Leads Manager
                <Link to="/leads-manager" />
              </Menu.Item>
            </Menu>
            <Feedback
              variant="sidebar"
              collapsed={collapsed}
              companyContext={
                selected
                  ? {
                      company_name: selected.company_name,
                      user_input: selected.user_input,
                    }
                  : null
              }
            />
            {!collapsed && (
              <div className="absolute logo-container">
                <img src={logo} className="z-10" />
              </div>
            )}
          </Sider>
        ) : null}
        <Layout className="site-layout">
          {loading ? (
            <div
              className="flex justify-center"
              style={{
                backgroundColor: "#fff",
                padding: 24,
                height: "calc(100vh - 65px)",
              }}
            >
              <video autoPlay muted loop>
                <source src={MotionVideo} type="video/mp4" />
              </video>
            </div>
          ) : (
            <Content
              className={`site-layout-background overflow-scroll ${
                exiprePreview ? "expire-view" : ""
              }`}
              style={{
                position: "relative",
                padding: 24,
                height: "calc(100vh - 65px)",
              }}
            >
              {isLoading ? (
                <div
                  className="loading-screen"
                  style={{ minHeight: "calc(100vh - 70px)" }}
                >
                  <LayoutPageSkeleton />
                </div>
              ) : isSubscriptionExpired && investorsPage ? (
                <RenewSubscription subscription={state.subscription} />
              ) : (
                props.children
              )}
            </Content>
          )}
        </Layout>
        {listPreview && <TargetListProgresstModal />}
        <TargetListCompaniesProgresstModal
          isListGenerating={isListGenerating}
          preview={companyAlgoProgressPreview && isListGenerating && !listPreview}
          previewHandler={() => setCompanyAlgoProgressPreview(false)}
        />
        <AiTargetError />
      </Layout>
    </>
  );
};

export default MainLayout;
